import { type CalendarEvent } from '../calendar.models';

export interface CalendarEventPosition {
  left: number;
  top: number;
}

export interface CalendarEventDimensions {
  width: number;
  height: number;
}

const ONE_HOUR_IN_MS = 3_600_000;

export class CalendarEventLayout {
  private left = 0;
  private top = 0;
  private width = 0;
  private height = 0;
  private readonly LEFT_OVERFLOW_OFFSET = 0.1;
  private readonly MAX_POSITION = 24;
  index = 0;

  get position(): CalendarEventPosition {
    return {
      left: this.left,
      top: this.top,
    };
  }

  get dimensions(): CalendarEventDimensions {
    return {
      height: this.height,
      width: this.width,
    };
  }

  constructor(public readonly event: CalendarEvent) {}

  collidesWith({ event }: CalendarEventLayout): boolean {
    return this.event.endDate > event.startDate && this.event.startDate < event.endDate;
  }

  setPosition(index: number, totalInGroup: number): void {
    this.index = index;

    if (totalInGroup === 1) {
      this.width = 1 - this.LEFT_OVERFLOW_OFFSET;
      this.left = 0;
    } else {
      this.width = (1 - this.LEFT_OVERFLOW_OFFSET) / totalInGroup + this.LEFT_OVERFLOW_OFFSET;
      this.left = (index * (1 - this.LEFT_OVERFLOW_OFFSET - this.width)) / (totalInGroup - 1);
    }

    this.height = (this.event.endDate.getTime() - this.event.startDate.getTime()) / ONE_HOUR_IN_MS;
    this.top = this.event.startDate.getHours() + this.event.startDate.getMinutes() / 60;

    if (this.top + this.height > this.MAX_POSITION) {
      this.height = this.MAX_POSITION - this.top;
    }
  }
}
